<template>
  <!-- 警示彈窗頂部圖示：比照 UpGPT 既有彈窗（大型置中彩色 v-icon，例：messageDialog）-->
  <div class="ur-sel-modal-warn">
    <v-icon size="70" color="orange">icon-chat</v-icon>
  </div>
</template>

<script>
export default {
  name: 'UrbanRenewalSelectWarnIcon',
};
</script>
